import { ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { BrandLogo } from './BrandLogo';
import { surfaceShadows } from '../../surfaceStyles';

/** Shared presentation for the existing sign-in and account setup workflows. */
export function AuthShell({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <Box
      component="main"
      sx={{
        minHeight: '100dvh',
        '@supports not (height: 100dvh)': { minHeight: '100vh' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
        py: 'max(24px, env(safe-area-inset-top), env(safe-area-inset-bottom))',
      }}
    >
      <Paper
        variant="outlined"
        sx={{
          width: '100%',
          maxWidth: 456,
          p: { xs: 3, sm: 5 },
          borderRadius: 1,
          boxShadow: surfaceShadows.control,
        }}
      >
        <BrandLogo sx={{ fontSize: 48, textAlign: 'center', mb: 4 }} />
        <Typography
          component="h1"
          variant="h5"
          sx={{ textAlign: 'center', mb: 3 }}
        >
          {title}
        </Typography>
        {children}
      </Paper>
    </Box>
  );
}
